(ns ductile.ui.system
  "Ductile UI System

  Side-effectful requires like `ductile.ui.vehicle-search` are for
  deframe events."
  {:dev/always true}
  (:require [ductile.ui :as ui]
            [ductile.ui.deframe :as deframe]
            [ductile.ui.deframe.events :as deframe.events]
            [ductile.ui.edi]
            [ductile.ui.http :as http]
            [ductile.ui.locations]
            [ductile.ui.router :as router]
            [ductile.ui.transit :as transit]
            [ductile.ui.vehicle-search]
            [ductile.ui.websocket :as websocket]
            [goog.crypt]
            [goog.crypt.base64 :as base64]
            [nextjournal.commands.state :as commands.state]
            [nextjournal.log :as log]
            [nextjournal.view.expo :as expo]
            [re-frame.core :as re-frame]
            [taoensso.timbre]
            [taoensso.trove]
            [taoensso.trove.timbre]))

;; configure sente logging
(taoensso.trove/set-log-fn! (taoensso.trove.timbre/get-log-fn))
(taoensso.timbre/set-ns-min-level! "taoensso.sente(.*)" :warn)

(defonce system (atom nil))

(def config
  {::http/re-frame-registry  re-frame/default-frame
   ::websocket/client        {}
   ::router/router {:use-fragment? false}})

(def key->start-fn
  {::websocket/client websocket/init
   ::router/router router/init
   ::http/re-frame-registry expo/register-into-frame})

(defn init-system [config]
  (into {}
        (map (fn [[k cfg]]
               [k ((key->start-fn k) cfg)]))
        config))

(defn init! [config]
  (try
    (reset! system (init-system config))
    (catch :default e
      (log/error :message (ex-message e)
                 ::init! (ex-data e)
                 :exception (ex-cause e)))))

(defn base64-transit-decode
  [s]
  (-> s
      base64/decodeStringToByteArray
      goog.crypt/utf8ByteArrayToString
      transit/read))

(defn ^:export main [init-db-transit-base64]
  (log/debug :build-info ui/build-stamp)
  (deframe.events/register-events! {:ns-prefix "ductile.ui"})
  (let [init-db (base64-transit-decode init-db-transit-base64)]
    (js/console.log :db init-db :connect? (some? (:current-user init-db)))
    (init! (assoc config ::websocket/client {:connect? (some? (:current-user init-db))}))
    (deframe/init-db! (-> init-db
                          (assoc ::deframe/current-route (router/current-route))
                          (merge (commands.state/empty-db!))))
    (ui/main {})))

(comment

  (init-system config)
  (init! config))
